// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import * as $ from 'jquery';
import VueHighcharts from 'vue-highcharts';
import Highcharts from 'highcharts';
import PatternFill from './../../vendor/pattern-fill-v2';
import BrokenAxis from './../../vendor/broken-axis';
import App from './App';
import router from './router';

PatternFill(Highcharts);
BrokenAxis(Highcharts);

Vue.use(VueHighcharts, { Highcharts });
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  mounted() {
    window.onscroll = function() {
      scrollFunction();
    };

    const browserName = getBrowserInfo().split(' ')[0];

    if (browserName === 'Safari') {
      $('div#using-safari').show();
    } else {
      $('div#using-safari').hide();
    }

    function scrollFunction() {
      if (!$('#toc')[0]) {return}

      if (document.body.scrollTop > $('#toc')[0].offsetTop + 10 || document.documentElement.scrollTop > $('#toc')[0].offsetTop + 10) {
        document.getElementById("go-to-top").style.display = "block";
      } else {
        document.getElementById("go-to-top").style.display = "none";
      }
    }

    function getBrowserInfo() {
      var ua = navigator.userAgent, tem,
    	M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    	if(/trident/i.test(M[1]))
    	{
    		tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
    		return 'IE '+(tem[1] || '');
    	}
    	if(M[1]=== 'Chrome')
    	{
    		tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
    		if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    	}
    	M = M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    	if((tem= ua.match(/version\/(\d+)/i))!= null)
    		M.splice(1, 1, tem[1]);
    	return M.join(' ');
    }
  },
})



// WEBPACK FOOTER //
// ./src/web/main.js